<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/elUYeK/tc-custom/9781685504090.jpg?1723403766540" alt="This image is the cover for the book Next Year in Salem"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Next Year in Salem
      </h1>
      <p class="bookDescription body article font2">
        <p>Natalie Durham is sick of men. After her latest boyfriend cheats on her, she skips town to her aunt's place in Boston and vows to burn all the things her exes have given her. Maybe she'll even do a spell or two, since she'll be close enough to Salem to venture over.<br/><br/>Melissa Clarke is a former model now ready to live authenticity as both a lesbian and a foodie. She leaves her boyfriend, travels to her Boston home, and is determined to make the best Thanksgiving meal ever.<br/><br/>When Natalie suffers car trouble, and Melissa steps up to help, it should be a brief encounter. But these women soon find out they have a lot more in common than they first believed, and it may be enough -- with some magick -- to change the rest of their lives.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eve Morton
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      JMS Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cf61eede